import { trackingEventTypes } from "../constants";
import { TrackingConfiguration } from "@vviinn/user-managment-client-ts";

export const trackingConfig = (
  booleanTrack: boolean,
): TrackingConfiguration => ({
  track: booleanTrack,
  events: trackingEventTypes.map((typ) => ({
    typ,
    enabled: booleanTrack,
  })),
});
